import React from "react";

import { useAppDispatch } from "../../../Core/redux/hooks";
import { resetConversations } from "../../../Core/redux/slices/conversations.slice";
import ParseMentions from "../ParseMentions";
import { Attachments } from "../../../ModulesV2/Conversations/Message";

const ReplyMessageFlow = ({ replyMessage }) => {
  const dispatch = useAppDispatch();
  const renderFileTag = (mimeType = "") => {
    if (mimeType.includes("pdf")) {
      return { url: "/images/v2/library/pdf-file-icon.svg", type: "Pdf" };
    } else if (mimeType.includes("excel") || mimeType.includes("spreadsheet")) {
      return { url: "/images/v2/library/excel-file-icon.svg", type: "Excel" };
    } else if (mimeType.includes("image")) {
      return { url: "/images/v2/library/image-file-icon.svg", type: "Photo" };
    } else if (mimeType.includes("video")) {
      return { url: "/images/v2/library/video-file-icon.svg", type: "Video" };
    } else {
      return { url: "/images/v2/library/default-file-icon.svg", type: "File" };
    }
  };
  const fileTag = renderFileTag(
    replyMessage?.messageObject?.attachments
      ? replyMessage?.messageObject?.attachments[0]?.type
      : ""
  );
  return (
    <div className="bg-white  px-2 pt-2 pb-1">
      <div className="bg-[#EDF3F9] border border-[#DDE5ED] p-2 rounded-lg relative">
        <div className="flex w-full justify-between   gap-y-1">
          <div className="flex flex-col w-full ">
            <div className="flex items-center justify-between">
              {" "}
              <span className=" out-600-14 text-gray-700 capitalize">
                {replyMessage?.messageObject?.senderName}
              </span>
            </div>
            <div className="flex h-full items-center gap-1 ">
              {replyMessage?.messageObject?.attachments &&
                replyMessage?.messageObject?.attachments?.length > 0 && (
                  <div className="flex items-center gap-x-1">
                    <div className="w-4 h-4  ">
                      <img src={fileTag.url} />
                    </div>
                    <p className=" text-gray-500 out-300-14">{fileTag?.type}</p>
                  </div>
                )}
              <ParseMentions
                value={replyMessage?.messageObject?.content}
                textClassName="text-gray-500 out-300-14"
              />
            </div>
          </div>
          <div className="flex justify-between ">
            {replyMessage?.messageObject?.attachments &&
              replyMessage?.messageObject?.attachments.length > 0 && (
                <div
                  className="h-[56px] w-[56px] bg-no-repeat bg-center bg-cover rounded-lg relative flex justify-center items-center"
                  style={{
                    backgroundImage: `linear-gradient(0deg, rgba(16, 24, 40, 0.2), rgba(16, 24, 40, 0.2)), url(${replyMessage?.messageObject.attachments[0].url ||
                      replyMessage?.messageObject.attachments[0].thumbnail ||
                      fileTag?.url
                      })`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                />
              )}
          </div>
        </div>

        {/* Left accent bar — Figma: 2px wide, 48px tall, 2px radius, Primary/500 #2E90FA */}
        <div
          className="bg-primary-500 top-2 bottom-2 left-0 w-[2px] h-[calc(100%-16px)] absolute rounded-[2px]"
        ></div>

        <div
          className="absolute top-2 right-2 cursor-pointer"
          onClick={() => dispatch(resetConversations(["replyMessage"]))}
        >
          <img src={"/images/v3/conversations/closeRounded.svg"} />
        </div>
      </div>
    </div>
  );
};

export default ReplyMessageFlow;